import { useEffect } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { ANALYTICS_PREFIX } from "../../common/constants";
import { PageProjectDetailsProps } from "../../common/types";
import { LeftHandSideWrapper } from "../../common/ui/left-hand-side-wrapper/left-hand-side-wrapper";
import { RightHandSideWrapper } from "../../common/ui/right-hand-side-wrapper/right-hand-side-wrapper";
import { useWizardConfiguration } from "../../controllers";

import { LeftHandSidePageProjectDetails } from "./left-hand-side/left-hand-side";
import { RightHandSidePageProjectDetails } from "./right-hand-side/right-hand-side";

export const PageProjectDetails = (props: PageProjectDetailsProps) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const {
        teamType,
        projectDetails: { template }
    } = useWizardConfiguration();

    useEffect(() => {
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: `${ANALYTICS_PREFIX}ProjectDetails`,
            attributes: {
                teamType: teamType,
                template: template
            }
        }).fire();
    }, [createAnalyticsEvent, template, teamType]);

    return (
        <>
            <LeftHandSideWrapper>
                <LeftHandSidePageProjectDetails {...props} />
            </LeftHandSideWrapper>

            <RightHandSideWrapper>
                <RightHandSidePageProjectDetails
                    projectName={
                        props.currentProjectName !== undefined
                            ? props.currentProjectName
                            : props.defaultProjectName
                    }
                />
            </RightHandSideWrapper>
        </>
    );
};
